import React from "react";
import { ReleaseDetailForm } from "../../../Components/ReleaseDetailForm";

export const ReleaseDetailStep: React.FC = () => {
  return <ReleaseDetailForm mode="add" />;
};
